import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../config/api';

// Prompts self-registered customers (no center, email unverified) to verify.
// The button takes them to the profile "Chỉnh sửa hồ sơ" tab where they verify.
export default function EmailVerifyBanner() {
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!token) return;
    fetch(`${API_BASE}/student/email-status`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d) setStatus(d); })
      .catch(() => {});
  }, [token]);

  if (!status || !status.show_verify) return null;

  return (
    <div className="bg-amber-50 border-b border-amber-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <div className="flex items-start gap-2 min-w-0 flex-1">
          <svg className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
          <p className="text-sm text-gray-700 min-w-0">
            <span className="font-semibold text-[#2b5356]">Xác thực email</span>
            {' '}— để dùng cho đặt lại mật khẩu khi quên & các thao tác bảo mật.
          </p>
        </div>
        <button onClick={() => navigate('/profile?tab=edit')}
          className="shrink-0 px-4 py-2 rounded-lg text-sm font-bold text-white bg-[#0096b1] hover:bg-[#007d93] whitespace-nowrap">
          Xác thực ngay
        </button>
      </div>
    </div>
  );
}
